import { createSubstore } from 'storeon-substore';
import { StoreonStore } from 'storeon';
import type { Store } from 'store/types';
import { ReviewsStore } from '../reviews-types';
import { POST_REVIEW } from './post-review-constants';
import { PostReviewRequest } from './post-review-types';
import { postReviewAction } from './post-review-actions';

export const postReview = (parentStore: StoreonStore<ReviewsStore>, rootStore: Store) => {
  const postReviewStore = createSubstore(parentStore, 'postReview');

  postReviewStore.on(POST_REVIEW.init, async (_, review: PostReviewRequest) => {
    const { modelJson, orchestratorHost, useCredentials, apiKey, requestID } = rootStore.get();

    if (!modelJson.model) {
      return Promise.resolve();
    }

    postReviewStore.dispatch(POST_REVIEW.request);

    try {
      await postReviewAction(
        modelJson.model.properties.regionId,
        review,
        { orchestratorHost, useCredentials, apiKey, requestID }
      );
      postReviewStore.dispatch(POST_REVIEW.success);
    } catch (e) {
      if (e instanceof Error) {
        const error = {
          message: 'Не удалось отправить отзыв, попробуйте позже',
          status: 'ERROR',
        }

        if (e.message?.includes('"error":"taken"')) {
          error.message = 'Отзыв уже отправлен';
          error.status = 'CONFLICT';
        }

        postReviewStore.dispatch(POST_REVIEW.failure, error);
      }
    }
  });
  postReviewStore.on(POST_REVIEW.request, state => ({
    ...state,
    isProcessing: true,
    message: null,
    status: null,
  }));
  postReviewStore.on(POST_REVIEW.success, (state) => ({
    ...state,
    isProcessing: false,
    status: 'SUCCESS',
    message: 'Отзыв успешно отправлен',
  }));
  postReviewStore.on(POST_REVIEW.failure, (state, { message, status }) => ({
    ...state,
    isProcessing: false,
    message,
    status,
  }));
};
